import { api } from 'services/api';

export class XpcellService {
  //FINANCIAL CLOSING
  async searchFinancialClosing(data) {
    return await api.get('/xpcell/financial/closing', {
      params: {
        date: data,
      },
    });
  }

  async createFinancialClosing(data) {
    return await api.post('/xpcell/financial/closing', data);
  }

  async getClosingTypes() {
    return await api.get('/xpcell/financial/closing/types');
  }

  //GRAPHIC
  async getBudgetApprovedGraphic() {
    return await api.get('/xpcell/sac/graphic/budget-approved');
  }

  async getBudgetApprovedMonthGraphic() {
    return await api.get('/xpcell/sac/graphic/budget-approved-month');
  }

  async getBudgetRepprovedGraphic() {
    return await api.get('/xpcell/sac/graphic/budget-repproved');
  }

  //INVOICES
  async createNewKitInvoice(data) {
    return await api.post('/xpcell/invoices/new/kit', data);
  }

  async getClient(code, interprise) {
    return await api.get(`/xpcell/invoices/new/kit/${code}/${interprise}`);
  }

  async validatedServiceOrderForFinancialClosing(transmission_data) {
    return await api.post('/xpcell/financial/closing/validated', transmission_data);
  }

  //STATUS
  async getStatusGspn() {
    return await api.get('/xpcell/gspn/status');
  }

  async getSubStatusGspn() {
    return await api.get('/xpcell/gspn/sub/status');
  }

  //DASHBOARD
  async getServiceOrderByStatus() {
    return await api.get('/xpcell/dashboard/service-order-by-status');
  }

  async getTechDashboard() {
    return api.get('/xpcell/dashboard/tech-dashboard');
  }

  //STEPS
  async getProcess() {
    return api.get('xpcell/process');
  }

  async getServiceTypes() {
    return api.get('xpcell/service-types');
  }

  async getSteps() {
    return api.get('xpcell/steps');
  }

  //MESSAGES
  async getSettingsMessage() {
    return api.get('xpcell/settings-message');
  }

  async createSettingsMessage(data) {
    return api.post('xpcell/settings-message', data);
  }

  async updateSettingsMessage(data) {
    return api.put('xpcell/settings-message', data);
  }

  async disableSettingsMessage(id) {
    return api.delete(`xpcell/settings-message/${id}`);
  }

  //CONTIGO
  async listContigoStock(data) {
    return api.get('xpcell/contigo-stock', { params: data });
  }

  //STOCK
  async listComponentSellPrice(data) {
    return api.get('xpcell/stock/sell-price', { params: data });
  }

  async createComponentSellPrice(data) {
    return api.post('xpcell/stock/sell-price', data);
  }

  async updateManyComponentSellProcess(data) {
    return api.put('xpcell/stock/many-sell-price', data);
  }

  async updateComponentSellProcess(data) {
    return api.put('xpcell/stock/sell-price', data);
  }
}

export const xpcellService = new XpcellService();
